import { NgModule, Type } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CovalentHttpModule, IHttpInterceptor } from '@covalent/http';
import { CovalentHighlightModule } from '@covalent/highlight';
import { CovalentMarkdownModule } from '@covalent/markdown';
import { AppComponent } from './app.component';
import { Configuration } from './app.constants';
import { AppRoutingModule } from './app-routing.module';
import { RequestInterceptor } from 'config/interceptors/request.interceptor';
import { SharedModule } from './shared/shared.module';
import { HomescreenComponent } from './agatextscreens/homescreen/homescreen.component';
// import { HeaderComponent } from './agatextscreens/header/header.component';
import { LoginComponent } from './agatextscreens/login/login.component';
import { PurchasingProductsListComponent } from './agatextscreens/purchasing/products/products-list/purchasing-products-list.component';
import { CovalentDataTableModule, CovalentDialogsModule, CovalentFileModule, CovalentLoadingModule } from '@covalent/core';
import { HomepageComponent } from './agatextscreens/homepage/homepage.component';
import { CovalentDynamicFormsModule } from '@covalent/dynamic-forms';
import { PurchasingProductComponent } from './agatextscreens/purchasing/products/product/purchasing-product.component';
import { ProductService } from './agatextscreens/purchasing/products/product.service';
import { CatalogService } from './agatextscreens/purchasing/catalogs/catalog.service';
import { MdInputModule, MdSelectModule, MdAutocompleteModule, MdRadioModule, MdProgressBarModule } from '@angular/material';
import { SuppliersListComponent } from './agatextscreens/purchasing/suppliers/suppliers-list/suppliers-list.component';
import { SuppliersSaveComponent } from './agatextscreens/purchasing/suppliers/suppliers-save/suppliers-save.component';
import { SupplierService } from './agatextscreens/purchasing/suppliers/supplier.service';
import { PoListComponent } from './agatextscreens/purchasing/pos/po-list/po-list.component';
import { PoService } from './agatextscreens/purchasing/pos/po.service';
import { PoNewComponent } from './agatextscreens/purchasing/pos/po-new/po-new.component';
import { PoOrdersListComponent } from './agatextscreens/purchasing/pos/po-orders-list/po-orders-list.component';
import { ReceivingListComponent } from './agatextscreens/receiving/receiving-list/receiving-list.component';
import { ReceivingService } from './agatextscreens/receiving/receiving.service';
import { AccountingService } from './agatextscreens/accounting/accounting.service';
import { ReceivingEditComponent } from './agatextscreens/receiving/receiving-edit/receiving-edit.component';
import { ReceivingItemsComponent } from './agatextscreens/receiving/receiving-items/receiving-items.component';
import { InventoryListComponent, PictureDialog, ReservedDialog, OrderedDialog, MissingDialog }
  from './agatextscreens/inventory/inventory-list/inventory-list.component';
import { InventoryPiecesComponent } from './agatextscreens/inventory/inventory-pieces/inventory-pieces.component';
import { InventoryService } from './agatextscreens/inventory/inventory.service';
import { SalesListComponent } from './agatextscreens/sales/sales-list/sales-list.component';
import { SalesNewComponent } from './agatextscreens/sales/sales-new/sales-new.component';
import { SalesService } from './agatextscreens/sales/sales.service';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MdSidenavModule } from '@angular/material';
import 'rxjs/add/observable/of';
import { UserNewComponent } from './agatextscreens/admin/user-new/user-new.component';
import { UserListComponent } from './agatextscreens/admin/user-list/user-list.component';
import { OptionsComponent } from './agatextscreens/admin/options/options.component';
import { LocationService } from 'services/location.service';
import { Utils } from 'services/utils.service';
import { InventoryPieceComponent } from './agatextscreens/inventory/inventory-piece/inventory-piece.component';
import { AuthenticationService } from './shared/services/authentication.service';
import { AuthenticationGuard } from './shared/guards/authentication.guard';
import { BranchesListComponent } from './agatextscreens/accounting/branches/branches-list/branches-list.component';
import { BranchesSaveComponent } from './agatextscreens/accounting/branches/branches-save/branches-save.component';
import { BranchService } from './agatextscreens/accounting/branches/branch.service';
import { CustomerListComponent } from './agatextscreens/accounting/customer/customer-list/customer-list.component';
import { CustomerComponent, CreditDialog } from './agatextscreens/accounting/customer/customer/customer.component';
import { PdaInventoryComponent } from './agatextscreens/pda/inventory/pda-inventory.component';
import { PdaInvMainComponent } from './agatextscreens/pda/inventory/main/pda-inv-main.component';
import { InvChangeLocationComponent } from './agatextscreens/pda/inventory/change-pallet/change-pallet.component';
import { InvFindProductComponent } from './agatextscreens/pda/inventory/find-product/find-product.component';
import { InvFindItemComponent } from './agatextscreens/pda/inventory/find-item/find-item.component';
import { InvListItemsComponent } from './agatextscreens/pda/inventory/list-items/list-items.component';
import { InvCutItemComponent } from './agatextscreens/pda/inventory/cut-item/cut-item.component';
import { PoBranchToBranchComponent } from './agatextscreens/purchasing/po-branch-to-branch/po-branch-to-branch.component';
import { PdaShippingComponent } from './agatextscreens/pda/shipping/pda-shipping.component';
import { PdaShippingMainComponent } from './agatextscreens/pda/shipping/main/pda-shipping-main.component';
import { PrepareOrderComponent } from './agatextscreens/pda/shipping/prepare-order/prepare-order.component';
import { CheckOrderComponent } from './agatextscreens/pda/shipping/check-order/check-order.component';
import { ShipOrderComponent } from './agatextscreens/pda/shipping/ship-order/ship-order.component';
import { PdaReceivingComponent } from './agatextscreens/pda/receiving/pda-receiving.component';
import { PdaReceivingMainComponent } from './agatextscreens/pda/receiving/main/pda-receiving-main.component';
import { ScanComponent } from './agatextscreens/pda/receiving/scan/scan.component';
import { TransferComponent } from './agatextscreens/pda/receiving/transfer/transfer.component';
import { PrintLabelsComponent } from './agatextscreens/pda/receiving/print-labels/print-labels.component';
import { ScanPiecesComponent } from './agatextscreens/pda/receiving/scan/scan-pieces/scan-pieces.component';
import { UnitPriceComponent } from './agatextscreens/admin/unit-price/unit-price.component';
import { SettingsService } from './shared/services/settings.service';
import { CityCountryComponent, NewCityDialog } from './agatextscreens/admin/city-country/city-country.component';
import { ExportService } from './shared/services/export.service';
import { PrintRollLabelComponent } from './agatextscreens/pda/inventory/print-roll-label/print-roll-label.component';
import { PrintProductLabelComponent } from './agatextscreens/pda/inventory/print-product-label/print-product-label.component';
import { PrintLocationLabelComponent } from './agatextscreens/pda/inventory/print-location-label/print-location-label.component';
import { PageNotFoundComponent } from './agatextscreens/page-not-found/page-not-found.component';
import { TranslatePipe } from './shared/pipes/translate.pipe';
import { PrepareOrderItemsComponent } from './agatextscreens/pda/shipping/prepare-order-items/prepare-order-items.component';
import { ShipOrderItemsComponent } from './agatextscreens/pda/shipping/ship-order-items/ship-order-items.component';
import { LocationComponent, NewLocationDialog } from './agatextscreens/admin/location/location.component';
import { CollectionsListComponent, NewCollectionDialog } from './agatextscreens/purchasing/collections-list/collections-list.component';
import { DesignsListComponent, NewDesignDialog } from './agatextscreens/purchasing/designs-list/designs-list.component';
import { InlineCutComponent } from './shared/dialogs/inline-cut/inline-cut.component';
import { DateRangeDialogComponent } from './shared/dialogs/date-range-dialog/date-range-dialog.component';
import { BackorderListComponent } from './agatextscreens/sales/backorder-list/backorder-list.component';
import { BackorderComponent } from './agatextscreens/sales/backorder/backorder.component';
import { RefundListComponent } from './agatextscreens/sales/refund-list/refund-list.component';
import { RefundComponent } from './agatextscreens/sales/refund/refund.component';
import { SelectSimilarPieceComponent } from './shared/dialogs/select-similar-piece/select-similar-piece.component';
import { InvoiceListComponent } from './agatextscreens/accounting/invoice-list/invoice-list.component';
import { PaymentComponent } from './agatextscreens/accounting/payment/payment.component';
import { ChequesListComponent } from './agatextscreens/accounting/cheques-list/cheques-list.component';
import { AccountListComponent } from './agatextscreens/accounting/account-list/account-list.component';
import { AccountComponent } from './agatextscreens/accounting/account/account.component';
import { AccountLedgerComponent } from './agatextscreens/accounting/account-ledger/account-ledger.component';
import { AccountTransferComponent } from './agatextscreens/accounting/account-transfer/account-transfer.component';
import { AccountDepositComponent } from './agatextscreens/accounting/account-deposit/account-deposit.component';
import { AccountWithdrawalComponent } from './agatextscreens/accounting/account-withdrawal/account-withdrawal.component';
import { DepositChequeDialogComponent } from './shared/dialogs/deposit-cheque-dialog/deposit-cheque-dialog.component';
import { NewAdvanceDialogComponent } from './shared/dialogs/new-advance-dialog/new-advance-dialog.component';
import { NewCreditDialogComponent } from './shared/dialogs/new-credit-dialog/new-credit-dialog.component';
import { ReturnPiecesComponent } from './agatextscreens/pda/receiving/returns/return-pieces/return-pieces.component';
import { ReturnComponent } from './agatextscreens/pda/receiving/returns/returns.component';
import { SelectCustomerDialog } from './shared/dialogs/select-customer-dialog/select-customer-dialog.component';
import { ImportComponent } from './agatextscreens/pda/import/import.component';
import { DateSelectDialogComponent } from './shared/dialogs/date-select-dialog/date-select-dialog.component';
import { DebitNoteListComponent } from './agatextscreens/sales/debit-note-list/debit-note-list.component';
import { DebitNoteComponent } from './agatextscreens/sales/debit-note/debit-note.component';
import { NewInvoiceDialogComponent } from './shared/dialogs/new-invoice-dialog/new-invoice-dialog.component';
import { CreditDetailsComponent } from './shared/dialogs/credit-details/credit-details.component';
import { NewReceivedPieceComponent } from './shared/dialogs/new-received-piece/new-received-piece.component';
import { NewPreparedPieceComponent } from './shared/dialogs/new-prepared-piece/new-prepared-piece.component';
import { CatalogComponent } from './agatextscreens/purchasing/catalogs/catalog/catalog.component';
import { CatalogListComponent } from './agatextscreens/purchasing/catalogs/catalog-list/catalog-list.component';
import { InvoiceDetailsDialogComponent } from './shared/dialogs/invoice-details-dialog/invoice-details-dialog.component';
import { DateAndProductSelectDialogComponent } from './shared/dialogs/date-and-product-select-dialog/date-and-product-select-dialog.component';
import { SalesForcastingComponent, ColorDetailsDialog } from './agatextscreens/sales/sales-forcasting/sales-forcasting.component';
import { FabrictypelistComponent } from './agatextscreens/purchasing/fabrictypes/fabrictypelist/fabrictypelist.component';
import { FabrictypeComponent } from './agatextscreens/purchasing/fabrictypes/fabrictype/fabrictype.component';
import { FabrictypeService } from './agatextscreens/purchasing/fabrictypes/fabrictype.service';
import { PalletListComponent } from './agatextscreens/accounting/pallets/pallet-list/pallet-list.component';
import { PalletComponent } from './agatextscreens/accounting/pallets/pallet/pallet.component';
import { GradesComponent, NewGradeDialog } from './agatextscreens/accounting/grades/grades.component';
import { GradeService } from './shared/services/grade.service';

const httpInterceptorProviders: Type<any>[] = [
  RequestInterceptor,
];

@NgModule({
  declarations: [
    AppComponent,
    HomescreenComponent,
    // HeaderComponent,
    LoginComponent,
    PurchasingProductsListComponent,
    HomepageComponent,
    PurchasingProductComponent,
    SuppliersListComponent,
    SuppliersSaveComponent,
    PoListComponent,
    PoNewComponent,
    PoOrdersListComponent,
    ReceivingListComponent,
    ReceivingEditComponent,
    ReceivingItemsComponent,
    InventoryListComponent,
    InventoryPiecesComponent,
    SalesListComponent,
    SalesNewComponent,
    UserNewComponent,
    UserListComponent,
    OptionsComponent,
    InventoryPieceComponent,
    BranchesListComponent,
    BranchesSaveComponent,
    CustomerListComponent,
    CustomerComponent,
    PdaInventoryComponent,
    PdaInvMainComponent,
    InvChangeLocationComponent,
    InvFindProductComponent,
    InvFindItemComponent,
    InvListItemsComponent,
    InvCutItemComponent,
    PoBranchToBranchComponent,
    PdaShippingComponent,
    PdaShippingMainComponent,
    PrepareOrderComponent,
    CheckOrderComponent,
    ShipOrderComponent,
    PdaReceivingComponent,
    PdaReceivingMainComponent,
    ScanComponent,
    ReturnComponent,
    TransferComponent,
    PrintLabelsComponent,
    ScanPiecesComponent,
    ReturnPiecesComponent,
    UnitPriceComponent,
    CityCountryComponent,
    NewCityDialog,
    NewGradeDialog,
    NewLocationDialog,
    NewCollectionDialog,
    NewDesignDialog,
    SelectCustomerDialog,
    PictureDialog,
    CreditDialog,
    ReservedDialog,
    ColorDetailsDialog,
    OrderedDialog,
    MissingDialog,
    PrintRollLabelComponent,
    PrintProductLabelComponent,
    PrintLocationLabelComponent,
    PageNotFoundComponent,
    TranslatePipe,
    PrepareOrderItemsComponent,
    ShipOrderItemsComponent,
    LocationComponent,
    CollectionsListComponent,
    DesignsListComponent,
    InlineCutComponent,
    BackorderListComponent,
    BackorderComponent,
    RefundListComponent,
    RefundComponent,
    InvoiceListComponent,
    PaymentComponent,
    ChequesListComponent,
    AccountListComponent,
    AccountComponent,
    AccountLedgerComponent,
    AccountTransferComponent,
    AccountDepositComponent,
    AccountWithdrawalComponent,
    ImportComponent,
    DebitNoteListComponent,
    DebitNoteComponent,
    CreditDetailsComponent,
    NewReceivedPieceComponent,
    NewPreparedPieceComponent,
    CatalogComponent,
    CatalogListComponent,
    SalesForcastingComponent,
    FabrictypelistComponent,
    FabrictypeComponent,
    PalletListComponent,
    PalletComponent,
    GradesComponent,
  ], // directives, components, and pipes owned by this NgModule
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    MdInputModule,
    MdSelectModule,
    MdRadioModule,
    MdAutocompleteModule,
    MdProgressBarModule,
    CovalentHttpModule.forRoot({
      interceptors: [{
        interceptor: RequestInterceptor, paths: ['**'],
      }],
    }),
    CovalentHighlightModule,
    CovalentLoadingModule,
    CovalentMarkdownModule,
    CovalentDataTableModule,
    CovalentDialogsModule,
    CovalentDynamicFormsModule,
    CovalentFileModule,
  ], // modules needed to run this module
  providers: [
    Configuration,
    SalesService,
    InventoryService,
    ReceivingService,
    PoService,
    SupplierService,
    ProductService,
    CatalogService,
    LocationService,
    Utils,
    AccountingService,
    httpInterceptorProviders,
    Title,
    AuthenticationService,
    AuthenticationGuard,
    BranchService,
    SettingsService,
    ExportService,
    FabrictypeService,
    GradeService
  ], // additional providers needed for this module
  entryComponents: [
    NewCityDialog,
    NewGradeDialog,
    NewLocationDialog,
    PictureDialog,
    CreditDialog,
    ReservedDialog,
    ColorDetailsDialog,
    OrderedDialog,
    MissingDialog,
    InlineCutComponent,
    DateRangeDialogComponent,
    DateSelectDialogComponent,
    DateAndProductSelectDialogComponent,
    SelectSimilarPieceComponent,
    DepositChequeDialogComponent,
    NewAdvanceDialogComponent,
    NewCreditDialogComponent,
    SelectCustomerDialog,
    NewInvoiceDialogComponent,
    CreditDetailsComponent,
    NewReceivedPieceComponent,
    NewPreparedPieceComponent,
    InvoiceDetailsDialogComponent
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/app.module.ts